// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2s59d","boxTitle":"Qualiphy_boxTitle__14j3T","box":"Qualiphy_box__2gxp8","toggleWrap":"Qualiphy_toggleWrap__3R47H"};